"use strict";

var _objectSpread = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread");
var _objectWithoutProperties = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectWithoutProperties");
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _text = require("./text.tokens");
var _tokens = _interopRequireDefault(require("../../shared/tokens/tokens"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _jsxRuntime = require("react/jsx-runtime");
var StyledSubheading = _styledComponents.default.div.withConfig({
  displayName: "Subheading__StyledSubheading",
  componentId: "sc-rxlkuc-0"
})(["display:inline-block;", " color:", ";cursor:inherit;white-space:", ";", ""], function (_ref) {
  var size = _ref.size;
  return _tokens.default.sky.sys.font.subheading[size];
}, function (_ref2) {
  var color = _ref2.color;
  return _text.tokens.color.subheading[color];
}, function (_ref3) {
  var noWrap = _ref3.noWrap;
  return noWrap ? 'nowrap' : 'pre-wrap';
}, function (_ref4) {
  var ellipsis = _ref4.ellipsis;
  return ellipsis ? (0, _styledComponents.css)(["display:-webkit-box;-webkit-line-clamp:1;-webkit-box-orient:vertical;overflow:hidden;word-break:break-all;"]) : (0, _styledComponents.css)([""]);
});
var Subheading = function Subheading(_ref5) {
  var children = _ref5.children,
    size = _ref5.size,
    color = _ref5.color,
    noWrap = _ref5.noWrap,
    ellipsis = _ref5.ellipsis,
    props = _objectWithoutProperties(_ref5, ["children", "size", "color", "noWrap", "ellipsis"]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledSubheading, _objectSpread({
    size: size,
    color: color,
    noWrap: noWrap,
    ellipsis: ellipsis
  }, props, {
    children: children
  }));
};
var _default = exports.default = Subheading;
Subheading.defaultProps = {
  size: '1',
  color: 'default'
};